import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';
import Link from 'atomic/link/link';

import './contact.base.scss';

const ContactBase: React.FC = (): ReactElement => (
    <div className="contact">
        <div className="contact__body">
            <div className="contact__item">
                <Icon icon="shop" className="contact__icon" />
                <div className="contact__content">
                    <p className="contact__title">
                        Dla e-sklepów i firm:
                    </p>
                    <p className="contact__paragraph">
                        Jeśli masz pytania dotyczące programu Słucham Swoich Klientów, napisz do nas na adres
                    </p>
                    <p className="contact__paragraph">
                        <Link href="mailto:bok@opineo.pl">
                            bok@opineo.pl
                        </Link>
                    </p>
                </div>
            </div>
            <div className="contact__item">
                <Icon icon="desktop-repair" className="contact__icon contact__icon--desktop-repair" />
                <div className="contact__content">
                    <p className="contact__title">
                        W sprawach technicznych:
                    </p>
                    <p className="contact__paragraph">
                        W przypadku spraw technicznych skontaktuj się z&nbsp;nami pisząc na adres
                    </p>
                    <p className="contact__paragraph">
                        <Link href="mailto:admin@opineo.pl">
                            admin@opineo.pl
                        </Link>
                    </p>
                </div>
            </div>
            <div className="contact__item">
                <Icon icon="user-comment" className="contact__icon contact__icon--user-comment" />
                <div className="contact__content">
                    <p className="contact__title">
                        Dla użytkowników:
                    </p>
                    <p className="contact__paragraph">
                        <Link href="mailto:kontakt@opineo.pl">
                            kontakt@opineo.pl
                        </Link>
                    </p>
                </div>
            </div>
            <div className="contact__item">
                <Icon icon="comment-edit" className="contact__icon" />
                <div className="contact__content">
                    <p className="contact__title">
                        Dla mediów:
                    </p>
                    <p className="contact__paragraph">
                        Jeśli jesteś dziennikarzem lub redaktorem, skontaktujesz się z&nbsp;nami pod adresem
                    </p>
                    <p className="contact__paragraph">
                        <Link href="mailto:media@opineo.pl">
                            media@opineo.pl
                        </Link>
                    </p>
                </div>
            </div>
        </div>
        <div className="contact__details">
            <div className="contact__details-header">
                Usługodawcą Opineo.pl jest:
            </div>
            <div className="contact__details-label">
                Adres:
            </div>
            <div className="contact__details-content">
                Ringier Axel Springer Polska Sp. z o.o.
                {''}
                <br />
                {''}
                ul. Domaniewska 49
                {''}
                <br />
                {''}
                02-672 Warszawa
            </div>
            <div className="contact__details-label">
                Dane firmy:
            </div>
            <div className="contact__details-content">
                KRS: 0000420780
                {''}
                <br />
                {''}
                Kapitał zakładowy: 106 000 PLN (w całości wpłacony)
                {''}
                <br />
                {''}
                NIP: 527-267-70-09
                {''}
                <br />
                {''}
                Regon: 146127300
            </div>
            <div className="contact__details-label">
                E-mail:
            </div>
            <div className="contact__details-content">
                <Link href="mailto:kontakt@opineo.pl">
                    kontakt@opineo.pl
                </Link>
            </div>
            <hr className="contact__details-separator" />
            <div className="contact__details-header">
                Adres korespondencyjny:
            </div>
            <div className="contact__details-info">
                Serwis Opineo.pl
                {''}
                <br />
                {''}
                ul. Marii Curie-Skłodowskiej 12
                {''}
                <br />
                {''}
                50-381 Wrocław
            </div>
            <hr className="contact__details-separator" />
            <div className="contact__details-header">
                Numer telefonu do kontaktu:
            </div>
            <div className="contact__details-info">
                12 26 00 200 (pon-pt od 9:00 do 17:00)
            </div>
        </div>
    </div>
);

export default ContactBase;
